import React from "react";
import { Circle, Group, Text } from "react-konva";
import { markerColor } from "../../trackTrace/mapUtils";
import { TrackTraceAsset } from "../../trackTrace/types";

interface Props {
    asset: TrackTraceAsset;
    x: number;
    y: number;
    canvasScale: number;
    selected: boolean;
    onSelect: (asset: TrackTraceAsset) => void;
}

const AssetMarker: React.FC<Props> = ({ asset, x, y, canvasScale, selected, onSelect }) => {
    const freshness = asset.current_location?.freshness;
    const opacity = freshness === 'stale' ? 0.7 : freshness === 'old' ? 0.48 : 1;
    const fill = markerColor(asset.status, asset.status_color);
    const markerScale = 1 / Math.max(canvasScale, 0.001);

    return (
        <Group x={x} y={y} scaleX={markerScale} scaleY={markerScale} opacity={opacity} onTap={() => onSelect(asset)} onClick={() => onSelect(asset)}>
            <Circle radius={selected ? 18 : 14} fill={fill} stroke="#ffffff" strokeWidth={3} shadowColor="#0f172a" shadowBlur={5} shadowOpacity={0.2} />
            {(freshness === 'stale' || freshness === 'old') && <Text x={-4} y={-10} text="!" fill="#ffffff" fontSize={16} fontStyle="bold" />}
        </Group>
    );
};

export default AssetMarker;
